var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup9231(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 73,
    viewBox: "0 0 70 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9231",
    "data-name": "Group 9231",
    transform: "translate(-155 -185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9221",
    "data-name": "Group 9221"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13452",
    "data-name": "Rectangle 13452",
    width: 70,
    height: 73,
    rx: 35,
    transform: "translate(155 185)",
    fill: "#e1eaec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "seguro",
    transform: "translate(162 183.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9201",
    "data-name": "Group 9201",
    transform: "translate(0 13.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9200",
    "data-name": "Group 9200",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58555",
    "data-name": "Path 58555",
    d: "M48.062,44.4l-4.031-1.829-1.153-1.864A15.5,15.5,0,0,0,50.1,27.6V19.944a1.191,1.191,0,0,0-.641-1.025L39.1,13.408A1.134,1.134,0,0,0,38,13.419l-10.032,5.5a1.128,1.128,0,0,0-.583,1.025V27.75a15.56,15.56,0,0,0,1.352,6.443h-8.4a5.862,5.862,0,0,0-4.626,2.284l-4.579,6-7.69,2.1A4.664,4.664,0,0,0,0,49.061V52a4.722,4.722,0,0,0,4.684,4.684h.559a5.866,5.866,0,0,0,11.3,0H33.673a5.866,5.866,0,0,0,11.3,0h1.142A4.707,4.707,0,0,0,50.8,52V48.63A4.681,4.681,0,0,0,48.062,44.4ZM29.711,20.631,38.6,15.75l9.17,4.894V27.6a13.232,13.232,0,0,1-8.109,12.176h-.023l-1.119.478-.909-.408a13.212,13.212,0,0,1-7.9-12.106V20.631ZM10.894,58.6a3.53,3.53,0,1,1,3.53-3.53A3.528,3.528,0,0,1,10.894,58.6Zm28.429,0a3.53,3.53,0,1,1,3.53-3.53A3.528,3.528,0,0,1,39.323,58.6Zm9.158-6.618H48.47a2.377,2.377,0,0,1-2.354,2.354h-.979a5.863,5.863,0,0,0-11.628,0h-16.8a5.863,5.863,0,0,0-11.628,0h-.4A2.377,2.377,0,0,1,2.33,51.985V49.049a2.342,2.342,0,0,1,1.724-2.237l8.063-2.2a1.21,1.21,0,0,0,.629-.419l4.824-6.315a3.5,3.5,0,0,1,2.773-1.363h9.717a15.779,15.779,0,0,0,6.618,5.476l1.4.606a1.178,1.178,0,0,0,.932,0l1.573-.676c.082-.035.163-.07.233-.1l1.433,2.3a1.088,1.088,0,0,0,.5.443l4.358,1.969a2.348,2.348,0,0,1,1.375,2.109v3.356Z",
    transform: "translate(0 -13.269)",
    fill: "#0b71c3"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(197 206.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3647",
    "data-name": "Grupo 3647",
    transform: "translate(0 0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3599",
    "data-name": "Trazado 3599",
    d: "M4.759,3.916,7.67,1a.427.427,0,0,0,0-.6L7.419.141a.427.427,0,0,0-.6,0L3.9,3.053.984.141a.427.427,0,0,0-.6,0L.125.4a.426.426,0,0,0,0,.6L3.036,3.91.125,6.832a.427.427,0,0,0,0,.6l.256.26a.427.427,0,0,0,.6,0L3.9,4.783,6.808,7.7a.423.423,0,0,0,.3.125h0a.423.423,0,0,0,.3-.125l.264-.26a.427.427,0,0,0,0-.6Z",
    transform: "translate(0 -0.016)",
    fill: "#0b71c3",
    stroke: "#0b71c2",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup9231);
export default __webpack_public_path__ + "static/media/Group 9231.89ccf5274a45768810b21b8f5fa53d30.svg";
export { ForwardRef as ReactComponent };